import { OFFICE_ROLES, type Role } from "@mandrac/shared";

/** A same-site path inside the app (`/admin…` or `/dock…`); anything else could send the user off-site. */
export function safeNext(next: string | null | undefined): string | null {
  if (!next || !/^\/(admin|dock)(?:[/?#]|$)/.test(next) || next.includes("\\")) return null;
  return next;
}

/** Where a signed-in user starts: the office for anyone with an office role, the dock for dock staff only. */
export function homeFor(me: { roles: Role[]; isPlatformAdmin: boolean }): "/admin" | "/dock" {
  const office = me.isPlatformAdmin || me.roles.some((r) => OFFICE_ROLES.includes(r));
  return !office && me.roles.includes("dock_staff") ? "/dock" : "/admin";
}

/** `/login` that returns to `next` after sign-in. */
export function loginPath(next: string): string {
  return `/login?next=${encodeURIComponent(next)}`;
}
